import { ProductMapper } from '@infrastructure/product/mappers/ProductMapper';
import { Supplier, SupplierAddress, SupplierProduct } from '@domain/suppliers/models/Supplier';
import { SupplierDTO, SupplierAddressDTO, SupplierProductDTO } from '../dto/SupplierDTO';

export class SupplierMapper {
  static toModel(dto: SupplierDTO): Supplier {
    return {
      id: dto.id,
      name: dto.name,
      email: dto.email,
      phone: dto.phone,
      website: dto.website,
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt),
      isActive: dto.isActive,
      addresses: dto.addresses.map(SupplierMapper.addressToModel),
      supplierProducts: (dto.supplierProducts ?? dto.linkedProducts ?? []).map(SupplierMapper.supplierProductToModel)
    };
  }

  /** Supplier embedded on PO items or other partial payloads (arrays may be omitted). */
  static toModelEmbedded(dto: SupplierDTO): Supplier {
    return {
      id: dto.id,
      name: dto.name,
      email: dto.email ?? '',
      phone: dto.phone ?? '',
      website: dto.website,
      createdAt: new Date(dto.createdAt ?? 0),
      updatedAt: new Date(dto.updatedAt ?? 0),
      isActive: dto.isActive ?? true,
      addresses: (dto.addresses ?? []).map(SupplierMapper.addressToModel),
      supplierProducts: (dto.supplierProducts ?? dto.linkedProducts ?? []).map(SupplierMapper.supplierProductToModel),
    };
  }
  
  static addressToModel(dto: SupplierAddressDTO): SupplierAddress {
    return {
      id: dto.id,
      type: dto.type,
      name: dto.name,
      address: dto.address,
      city: dto.city,
      state: dto.state,
      zipCode: dto.zipCode,
      country: dto.country,
      isPrimary: dto.isPrimary
    };
  }

  static addressToDTO(model: SupplierAddress): SupplierAddressDTO {
    return {
      id: model.id,
      type: model.type,
      name: model.name,
      address: model.address,
      city: model.city,
      state: model.state,
      zipCode: model.zipCode,
      country: model.country,
      isPrimary: model.isPrimary
    };
  }

  static supplierProductToModel(dto: SupplierProductDTO): SupplierProduct {
    return {
      id: dto.id,
      product: dto.product ? ProductMapper.toModel(dto.product) : undefined,
      supplier: dto.supplier ? SupplierMapper.toModel(dto.supplier) : undefined,
      isMain: dto.isMain,
      purchasePrice: dto.purchasePrice ? parseFloat(dto.purchasePrice) : undefined,
      currency: dto.currency,
      minimumOrderQuantity: dto.minimumOrderQuantity ? parseFloat(dto.minimumOrderQuantity) : undefined,
      orderInMultiplesOf: dto.orderInMultiplesOf ? parseFloat(dto.orderInMultiplesOf) : undefined,
      minimumOrderQuantityType: dto.minimumOrderQuantityType,
    };
  }

} 